import { headerInterceptor } from "./header-interceptor";
import { bodyInterceptor } from "./body-interceptor";
import { jsonInterceptor } from "./json-interceptor";
import type { InterceptorFactory } from "./types";

export const HttpInterceptors: readonly InterceptorFactory[] = [
  headerInterceptor,
  bodyInterceptor,
  jsonInterceptor,
];
